/**
 * @description 優惠活動類型名稱用
*/
export enum PromotionTypeName {
    /** 全部 */
    All='全部',
    /** 活動列表 */
    Promotion = '活動列表',
    /** 得獎公告 */
    PrizeWinner = '得獎公告',
    /** 加值服務 */
    ValueAdd = '加值服務'
}
